import { TokenCheckUrl } from '../constants';
import { RequestHeaders } from './utilities';
export function checkToken(api) {
    return () => {
        return api.authenticated().get(TokenCheckUrl, {}, RequestHeaders);
    };
}
//# sourceMappingURL=checkToken.js.map